<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb(:data="items")
        el-col.pt-5.text-right(:span="15")
          el-button(type="primary" size="mini" @click="$router.go(-1)") 返回
    div(style="height:70px")
    el-main.white.pa-3.ma-4
      div.grey--lighten1.pl-3(style="height:48px;line-height:48px;font-size:14px;color:#909399;font-weight: bold;") 需求信息
      el-divider.my-0
      div.grey--lighten1.pl-3.py-3(style="line-height:24px;font-size:14px;color:#909399;font-weight: bold;")
        el-row
          el-col(:span="8")
            span 物料编码：{{head.code_material}}
          el-col(:span="8")
            span 物料名称：{{head.name_material}}
          el-col(:span="6")
            span 数量：{{head.source_num}}
        el-row
          el-col(:span="8")
            span 需求组织：{{head.name_stock_org}}
          el-col(:span="8")
            span 采购组织：{{head.name_buy_org}}
          el-col(:span="4")
            span 需求时间：{{head.order_date}}
          el-col(:span="4")
            span 备注：{{head.remark}}
      el-divider.my-0
      el-table.mb-6(:data="body" style="width: 100%" border header-cell-class-name="grey--lighten1" size="mini")
        el-table-column(prop="spec_material" label="规格" width="150" show-overflow-tooltip)
        el-table-column(prop="type_material" label="型号" width="100" show-overflow-tooltip)
        el-table-column(prop="unit_material" label="单位" width="50")
        el-table-column(prop="num" label="结存数量" width="100" show-overflow-tooltip)
        el-table-column(prop="price" label="含税价格(元)" width="120" show-overflow-tooltip)
        el-table-column(prop="money" label="价税合计(元)" width="120" show-overflow-tooltip)
        el-table-column(prop="address" label="存放地点" width="120" show-overflow-tooltip)
        el-table-column(prop="name_pk_org" label="录入组织" show-overflow-tooltip)
        el-table-column(prop="name_contact" label="录入人" width="80")
        el-table-column(prop="phone_contact" label="联系方式" width="100")
        el-table-column(prop="create_date" label="录入日期" width="100")
</template>
<script>
export default {
  data() {
    return {
      h: "",
      data: [],
      loading: false,
      items: [
        {
          path: "/purchase/purchase_demand",
          meta: {
            title: "采购需求"
          }
        },
        {
          path: this.$route.path,
          meta: {
            title: "闲置物资详情"
          }
        }
      ],
      head: {},
      body: []
    };
  },
  props: {
    id: {
      type: String,
      default: null
    },
    type: {
      type: [Number, String],
      default: 1
    }
  },
  methods: {
    async getById() {
      this.loading = true;
      let res = await this.$api.purchase_demand.getGoodsById(this.id);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.head = this.data.head;
        this.body = this.data.body;
      }
    }
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    this.getById();
  }
};
</script>